import { SubscriptionStatus } from '../interfaces/subscription';

export const RESTRICTED_SUBSCRIPTION_STATUSES: string[] = [
  SubscriptionStatus.NOT_FOUND,
  SubscriptionStatus.INVALID,
  SubscriptionStatus.PAST_DUE,
  // Currently, we don't restrict any other subscription status.
  // Users can use the app regardless of subscription status as long as they have a valid Stripe customer ID and don't owe us money
  // SubscriptionStatus.INCOMPLETE,
  // SubscriptionStatus.PAUSED,
  // SubscriptionStatus.EXPIRED,
  // SubscriptionStatus.INACTIVE,
  // SubscriptionStatus.UNKNOWN,
];

export const SUBSCRIPTION_LABELS: Record<string, string> = {
  [SubscriptionStatus.ACTIVE]: 'Active',
  [SubscriptionStatus.TRIALING]: 'Free Trial',
  [SubscriptionStatus.INACTIVE]: 'Inactive',
  [SubscriptionStatus.INCOMPLETE]: 'Incomplete',
  [SubscriptionStatus.EXPIRED]: 'Expired',
  [SubscriptionStatus.PAUSED]: 'Paused',
  [SubscriptionStatus.PAST_DUE]: 'Past Due',
  [SubscriptionStatus.FREE]: 'Free Plan',
  [SubscriptionStatus.UNKNOWN]: 'Unknown',
  [SubscriptionStatus.NOT_FOUND]: 'Not Found',
  [SubscriptionStatus.NOT_SUBSCRIBED]: 'Free Plan',
  [SubscriptionStatus.INVALID]: 'Invalid',
};
